"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PortalSettingsKeys = _interopRequireDefault(require("crm_data/constants/PortalSettingsKeys"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var ACTIVITY_TYPES_ENABLED = _PortalSettingsKeys.default.ACTIVITY_TYPES_ENABLED;
var _default = {
  stores: [_SettingsStore.default],
  deref: function deref() {
    var hasActivityTypes = _SettingsStore.default.get() && _SettingsStore.default.get().get(ACTIVITY_TYPES_ENABLED) === 'true';
    return hasActivityTypes;
  }
};
exports.default = _default;
module.exports = exports.default;